import { SeoActions } from '@store/reducers/seo/actions'
import { seoPanelShow } from '@storeOld/reducers/ui'
import { put } from 'redux-saga/effects'

export function* show({ payload }: ReturnType<typeof SeoActions.show>) {
  yield put(seoPanelShow(payload))
  yield put(SeoActions.init(payload))
}
